import {useRouter} from 'next/router';
import {twMerge} from '../../../common/twMerge';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {PcBackHeaderProps} from './PcBackHeaderProps';

export function PcBackHeader({className}: PcBackHeaderProps) {
  const router = useRouter();

  return (
    <div
      className={twMerge(
        'flex h-56pxr items-center mx-auto w-956pxr px-18pxr',
        className
      )}
    >
      <Icon
        type={IconType.NavigationBack}
        className="mr-16pxr h-24pxr w-24pxr shrink-0"
        onClick={() => router.back()}
      />
    </div>
  );
}
